module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "json.worker.a86e2f1f976b4138527b.js");
}
